import React, { useState } from "react";

export default function WeatherTemp(props) {
  let [unit, setUnit] = useState("celsius");
  function showF(event) {
    event.preventDefault();
    setUnit("fahrenheit");
  }
  function showC(event) {
    event.preventDefault();
    setUnit("celsius");
  }
  function fahrenheit(celsius) {
    return Math.round((celsius * 9) / 5 + 32);
  }
  if (unit === "celsius") {
    return (
      <span>
        {props.celsius}˚
        <span className="unit">
          C |
          <a onClick={showF} href="/">
            F
          </a>
        </span>
      </span>
    );
  }
  if (unit === "fahrenheit") {
    return (
      <span>
        {fahrenheit(props.celsius)}˚
        <span className="unit">
          F |
          <a onClick={showC} href="/">
            C
          </a>
        </span>
      </span>
    );
  }
}
